if (!customElements.get('blog-tag-search')) {
	class BlogTagSearch extends HTMLElement {
		constructor() {
			super();
			this.isOpen = false;
			this.tags = [];
			this.filteredTags = [];
			this.maxVisible = 100;
			this.currentlyShown = 0;
			this.boundOnKeyUp = this.onKeyUp.bind(this);
			this.boundOnClickOutside = this.onClickOutside.bind(this);
			this.boundOnScroll = null;
			this.isLoading = false;
		}

		connectedCallback() {
			var jsonScript = this.querySelector('script[data-blog-tags]');
			this.tags = jsonScript ? JSON.parse(jsonScript.textContent) : [];
			this.blogUrl = this.dataset.blogUrl || '';
			this.allLabel = this.dataset.allLabel || 'All';
			this.searchPlaceholder = this.dataset.searchPlaceholder || 'Search tags...';
			this.filterLabel = this.dataset.filterLabel || 'Filter by tag';
			this.noResultsText = this.dataset.noResults || 'No tags found';
			this.tagsCountText = this.dataset.tagsCount || '';
			this.activeTag = this.dataset.activeTag || '';
			this.maxVisible = parseInt(this.dataset.maxVisible, 10) || 100;

			this.render();
			this.cacheElements();
			this.setupEventListeners();
		}

		render() {
			var activePillHtml = '';
			if (this.activeTag) {
				activePillHtml =
					'<span class="blog-tag-search__active-pill">' +
						this.escapeHtml(this.activeTag) +
						'<a href="' + this.escapeAttr(this.blogUrl) + '" class="blog-tag-search__active-pill-remove" aria-label="' + this.escapeAttr(this.dataset.clearFilter || 'Clear filter') + '">' +
							'<svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="1" y1="1" x2="9" y2="9"/><line x1="9" y1="1" x2="1" y2="9"/></svg>' +
						'</a>' +
					'</span>';
			}

			this.innerHTML =
				'<div class="blog-tag-search__trigger-row">' +
					activePillHtml +
					'<div class="blog-tag-search__dropdown-wrap">' +
						'<button type="button" class="blog-tag-search__trigger-btn" aria-expanded="false">' +
							this.escapeHtml(this.filterLabel) +
							' <svg viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="1,1 5,5 9,1"/></svg>' +
						'</button>' +
						'<div class="blog-tag-search__dropdown">' +
							'<div class="blog-tag-search__drawer-header">' +
								'<h4 class="blog-tag-search__drawer-title">' + this.escapeHtml(this.filterLabel) + '</h4>' +
								'<button type="button" class="blog-tag-search__drawer-close" aria-label="Close">' +
									'<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/></svg>' +
								'</button>' +
							'</div>' +
							'<div class="blog-tag-search__search-wrap">' +
								'<svg class="blog-tag-search__search-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="6.5" cy="6.5" r="5.5"/><line x1="10.5" y1="10.5" x2="15" y2="15"/></svg>' +
								'<input type="text" class="blog-tag-search__search-input" placeholder="' + this.escapeAttr(this.searchPlaceholder) + '" autocomplete="off" />' +
								'<button type="button" class="blog-tag-search__search-clear" aria-label="Clear">' +
									'<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="1" y1="1" x2="11" y2="11"/><line x1="11" y1="1" x2="1" y2="11"/></svg>' +
								'</button>' +
							'</div>' +
							'<div class="blog-tag-search__list"></div>' +
							'<div class="blog-tag-search__loading"><svg class="blog-tag-search__spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" stroke-opacity="0.2"/><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"/></svg></div>' +
							'<div class="blog-tag-search__no-results">' + this.escapeHtml(this.noResultsText) + '</div>' +
							'<div class="blog-tag-search__count"></div>' +
						'</div>' +
					'</div>' +
				'</div>' +
				'<div class="blog-tag-search__overlay"></div>';
		}

		cacheElements() {
			this.triggerBtn = this.querySelector('.blog-tag-search__trigger-btn');
			this.dropdown = this.querySelector('.blog-tag-search__dropdown');
			this.searchInput = this.querySelector('.blog-tag-search__search-input');
			this.searchClear = this.querySelector('.blog-tag-search__search-clear');
			this.listContainer = this.querySelector('.blog-tag-search__list');
			this.countEl = this.querySelector('.blog-tag-search__count');
			this.noResultsEl = this.querySelector('.blog-tag-search__no-results');
			this.loadingEl = this.querySelector('.blog-tag-search__loading');
			this.drawerClose = this.querySelector('.blog-tag-search__drawer-close');
			this.overlay = this.querySelector('.blog-tag-search__overlay');
		}

		setupEventListeners() {
			this.triggerBtn.addEventListener('click', this.toggle.bind(this));

			var debouncedFilter = debounce(function () {
				this.filterTags(this.searchInput.value.trim());
				this.searchClear.classList.toggle('is-visible', this.searchInput.value.length > 0);
			}.bind(this), 200);

			this.searchInput.addEventListener('input', debouncedFilter);

			this.searchClear.addEventListener('click', function () {
				this.searchInput.value = '';
				this.searchClear.classList.remove('is-visible');
				this.filterTags('');
				this.searchInput.focus();
			}.bind(this));

			this.overlay.addEventListener('click', this.close.bind(this));
			this.drawerClose.addEventListener('click', this.close.bind(this));

			// Scroll to load more
			this.boundOnScroll = debounce(function () {
				this.onListScroll();
			}.bind(this), 100);
			this.listContainer.addEventListener('scroll', this.boundOnScroll);

			document.addEventListener('keyup', this.boundOnKeyUp);
			document.addEventListener('click', this.boundOnClickOutside);
		}

		onListScroll() {
			var el = this.listContainer;
			if (this.isLoading || this.currentlyShown >= this.filteredTags.length) return;
			if (el.scrollTop + el.clientHeight >= el.scrollHeight - 60) {
				this.isLoading = true;
				this.showLoading();
				setTimeout(function () {
					this.loadMore();
					this.hideLoading();
					this.isLoading = false;
				}.bind(this), 300);
			}
		}

		loadMore() {
			var start = this.currentlyShown;
			var end = Math.min(start + this.maxVisible, this.filteredTags.length);
			if (start >= end) return;

			var html = '';
			for (var i = start; i < end; i++) {
				var tag = this.filteredTags[i];
				var isActive = this.activeTag && tag.name === this.activeTag;
				html += '<a href="' + this.escapeAttr(tag.url) + '" class="blog-tag-search__tag' + (isActive ? ' active' : '') + '">' + this.escapeHtml(tag.name) + '</a>';
			}
			this.listContainer.insertAdjacentHTML('beforeend', html);
			this.currentlyShown = end;
			this.updateCount();
		}

		showLoading() {
			this.loadingEl.classList.add('is-visible');
		}

		hideLoading() {
			this.loadingEl.classList.remove('is-visible');
		}

		onKeyUp(e) {
			if (e.key === 'Escape' && this.isOpen) {
				this.close();
			}
		}

		onClickOutside(e) {
			if (this.isOpen && !this.contains(e.target)) {
				this.close();
			}
		}

		toggle() {
			if (this.isOpen) {
				this.close();
			} else {
				this.open();
			}
		}

		isMobile() {
			return window.innerWidth < 768;
		}

		open() {
			this.isOpen = true;
			this.dropdown.classList.add('is-open');
			this.overlay.classList.add('is-open');
			this.setAttribute('open', '');
			this.triggerBtn.setAttribute('aria-expanded', 'true');
			if (this.isMobile()) {
				document.body.style.overflow = 'hidden';
			}
			this.filterTags('');
			setTimeout(function () {
				this.searchInput.focus({ preventScroll: true });
			}.bind(this), 100);
		}

		close() {
			this.isOpen = false;
			this.dropdown.classList.remove('is-open');
			this.overlay.classList.remove('is-open');
			this.removeAttribute('open');
			this.triggerBtn.setAttribute('aria-expanded', 'false');
			this.searchInput.value = '';
			this.searchClear.classList.remove('is-visible');
			document.body.style.overflow = '';
		}

		filterTags(query) {
			var q = query.toLowerCase();
			if (q) {
				this.filteredTags = this.tags.filter(function (t) {
					return t.name.toLowerCase().indexOf(q) !== -1;
				});
			} else {
				this.filteredTags = this.tags;
			}
			this.renderTagList();
		}

		renderTagList() {
			var total = this.filteredTags.length;

			if (total === 0) {
				this.listContainer.innerHTML = '';
				this.currentlyShown = 0;
				this.noResultsEl.classList.add('is-visible');
				this.countEl.classList.remove('is-visible');
				return;
			}

			this.noResultsEl.classList.remove('is-visible');

			var end = Math.min(this.maxVisible, total);
			var html = '<a href="' + this.escapeAttr(this.blogUrl) + '" class="blog-tag-search__tag' + (!this.activeTag ? ' active' : '') + '">' + this.escapeHtml(this.allLabel) + '</a>';

			for (var i = 0; i < end; i++) {
				var tag = this.filteredTags[i];
				var isActive = this.activeTag && tag.name === this.activeTag;
				html += '<a href="' + this.escapeAttr(tag.url) + '" class="blog-tag-search__tag' + (isActive ? ' active' : '') + '">' + this.escapeHtml(tag.name) + '</a>';
			}

			this.listContainer.innerHTML = html;
			this.listContainer.scrollTop = 0;
			this.currentlyShown = end;
			this.updateCount();
		}

		updateCount() {
			var total = this.filteredTags.length;
			if (this.currentlyShown < total) {
				this.countEl.textContent = this.tagsCountText
					.replace('{{ shown }}', this.currentlyShown)
					.replace('{{ total }}', total);
				this.countEl.classList.add('is-visible');
			} else {
				this.countEl.classList.remove('is-visible');
			}
		}

		escapeHtml(str) {
			var div = document.createElement('div');
			div.textContent = str;
			return div.innerHTML;
		}

		escapeAttr(str) {
			return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		}

		disconnectedCallback() {
			document.removeEventListener('keyup', this.boundOnKeyUp);
			document.removeEventListener('click', this.boundOnClickOutside);
		}
	}

	customElements.define('blog-tag-search', BlogTagSearch);
}
